// extracted by mini-css-extract-plugin
export default {"Hooked":"hooked_Hooked__MnEr4","Slogan":"hooked_Slogan__wGVzB","LandingContent":"hooked_LandingContent__Gk+5Q","Panel":"hooked_Panel__nZs02","Offering":"hooked_Offering__cMmm4"};